import { render, staticRenderFns } from "./SaleTypePie.vue?vue&type=template&id=12cd4d3a&scoped=true&"
import script from "./SaleTypePie.vue?vue&type=script&lang=js&"
export * from "./SaleTypePie.vue?vue&type=script&lang=js&"
import style0 from "./SaleTypePie.vue?vue&type=style&index=0&id=12cd4d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd4d3a",
  null
  
)

export default component.exports